<template>
	<div class="row">
		<div class="col-12 col-lg-4 order-lg-2">
			<div class="card mb-8">
				<div class="card-header">
					<label>{{$t('outcome')}}</label>
				</div>
				<div class="card-body">
					<div class="form-group clear-left">
						<div class="btn-group">
							<button
								class="btn"
								v-bind:class="{
									'btn-on btn-on-good': test.HasPassed === 1,
									'btn-off': test.HasPassed !== 1
								}"
								@click="togglePassed(1)"
								:disabled="!isTeacher"
							>
								{{ getDichotomy('true') }}
							</button>
							<button
								class="btn"
								v-bind:class="{
									'btn-on btn-on-bad': test.HasPassed === 0,
									'btn-off': test.HasPassed !== 0
								}"
								v-on:click="togglePassed(0)"
								:disabled="!isTeacher"
							>
								{{ getDichotomy('false') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="col-12 col-lg-8 order-lg-1">
			<template v-if="test.form">
				<template v-for="(page, pageIndex) in test.form.pages">
					<div class="card mb-8" :key="pageIndex">
						<div class="card-header">
							<label>{{ page.title }}</label>
						</div>

						<div class="card-body">
							<FormGrid :page="page" :readonly="readonly" :viewAs="viewAs"></FormGrid>
						</div>
					</div>
				</template>
			</template>

			<div class="card mb-8">
				<div class="card-header">
					<label>{{$t('outcome')}}</label>
				</div>
				<div class="card-body">
					<div class="form-group clear-left">
						<div class="btn-group">
							<button
								class="btn"
								v-bind:class="{
									'btn-on btn-on-good': test.HasPassed === 1,
									'btn-off': test.HasPassed !== 1
								}"
								@click="togglePassed(1)"
								:disabled="!isTeacher"
							>
								{{ getDichotomy('true') }}
							</button>
							<button
								class="btn"
								v-bind:class="{
									'btn-on btn-on-bad': test.HasPassed === 0,
									'btn-off': test.HasPassed !== 0
								}"
								v-on:click="togglePassed(0)"
								:disabled="!isTeacher"
							>
								{{ getDichotomy('false') }}
							</button>
						</div>
					</div>
				</div>
			</div>

		</div>

	</div>

</template>

<script>
import FormGrid from "src/components/FormEditor/FormGrid";
export default {
	components: {
		FormGrid
	},
	props: {
		test: Object,
		readonly: Boolean
	},
	methods: {
		togglePassed(passed) {
			if (this.test.HasPassed !== passed) {
				this.test.HasPassed = passed;
			} else {
				this.test.HasPassed = -1;
			}
		},
		getDichotomy(type){
			if(this.$config.getValue('dichotomies') && this.test.dichotomy_id in this.$config.getValue('dichotomies')){
				return this.$config.getValue('dichotomies')[this.test.dichotomy_id][type]
			}
			if(type == 'true'){
				return this.$t('pass');
			}
			if(type == 'false'){
				return this.$t('fail');
			}
		}
	},
	computed: {
		viewAs: function() {
			if(this.isTeacher){
				return 'editall';
			}
			return 'submitter';
		},
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		}
	}
}
</script>
